var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawTeamworkZplp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 416.613,
    viewBox: "0 0 800 416.613",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70 -471)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(265.887 475.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(240.113 475.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(214.34 475.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(188.566 475.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(265.887 502.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(240.113 502.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(214.34 502.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(188.566 502.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(265.887 529.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(240.113 529.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(214.34 529.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(188.566 529.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(265.887 556.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(240.113 556.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(214.34 556.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(188.566 556.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(265.887 583.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(240.113 583.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(214.34 583.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(188.566 583.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(265.887 610.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(240.113 610.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(214.34 610.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(188.566 610.117)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.55,401.886v-175.5a7.53,7.53,0,0,1,7.521-7.521H772.8a7.53,7.53,0,0,1,7.521,7.521v175.5a7.53,7.53,0,0,1-7.521,7.521H634.072a7.53,7.53,0,0,1-7.521-7.521Zm7.521-181.35a5.857,5.857,0,0,0-5.85,5.85v175.5a5.857,5.857,0,0,0,5.85,5.85H772.8a5.857,5.857,0,0,0,5.85-5.85v-175.5a5.856,5.856,0,0,0-5.85-5.85Z",
    transform: "translate(-159.662 252.136)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.215,299.462V263.426a3.765,3.765,0,0,1,3.761-3.761h30.537a3.765,3.765,0,0,1,3.761,3.761v36.036a3.765,3.765,0,0,1-3.761,3.761H714.976a3.765,3.765,0,0,1-3.761-3.761Z",
    transform: "translate(-159.662 252.136)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.88,316.176V280.14a3.765,3.765,0,0,1,3.761-3.761h30.537a3.765,3.765,0,0,1,3.761,3.761v36.036a3.765,3.765,0,0,1-3.761,3.761H655.64a3.765,3.765,0,0,1-3.761-3.761Z",
    transform: "translate(-159.662 252.136)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.515,367.155V331.119a3.765,3.765,0,0,1,3.761-3.761h30.537a3.765,3.765,0,0,1,3.761,3.761v36.036a3.765,3.765,0,0,1-3.761,3.761H703.276A3.765,3.765,0,0,1,699.515,367.155Z",
    transform: "translate(-159.662 252.136)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(795.273 476.018)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(795.273 501.791)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(795.273 527.564)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(795.273 553.337)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(768.273 476.018)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(768.273 501.791)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(768.273 527.564)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(768.273 553.337)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(741.273 476.018)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(741.273 501.791)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(741.273 527.564)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(741.273 553.337)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(714.273 476.018)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(714.273 501.791)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(714.273 527.564)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(714.273 553.337)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(687.273 476.018)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(687.273 501.791)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(687.273 527.564)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(687.273 553.337)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(660.273 476.018)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(660.273 501.791)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(660.273 527.564)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.467,
    cy: 6.467,
    r: 6.467,
    transform: "translate(660.273 553.337)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.069,77.117,266.249,64l13.374,27.416-32.766,13.374Z",
    transform: "translate(51.883 582.068)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.653,66.67l30.759,35.44s-21.4,67.537-42.8,73.555-60.85,35.44-60.85,35.44l-49.483-32.1,24.073-35.44S189.532,64,204.912,64s24.741,2.675,24.741,2.675Z",
    transform: "translate(61.732 582.068)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.488,306.746h-71.6l-4.527-6.052L90.876,275.987,86.623,270.3s-16.048-29.422-12.7-56.169,38.115-32.766,38.115-32.766h1.431l42.568,37.406-2.541,34.812,13.481,22.4Z",
    transform: "translate(64.338 573.022)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.566,101.84l7.158,44.648-45.224.583V108.253Z",
    transform: "translate(18.863 579.151)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.828,266.711,808.441,279.1l-5.925,30.759H683.5c.929-6.894,2.2-16.817,3.557-27.53.134-1.07.274-2.146.408-3.23,3.4-26.928,7.128-57.4,7.128-57.4l15.647,1.9,30.358,3.678,12.371,1.5,33.127,4.019a28.7,28.7,0,0,1,24.735,33.922Z",
    transform: "translate(17.322 569.914)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.754,316.248H694.2c.983-1.157,1.538-1.826,1.538-1.826l19.352-3.2,39.874-6.58s1.819,4.7,3.791,11.6Z",
    transform: "translate(16.498 563.521)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.245,303.121H639.166l5.182-12.946,7.121-17.814,3.578-8.947-2.956-12.578s-1.458-1.03-3.678-2.882c-7.91-6.553-25.517-23.431-21.471-40.763,4.6-19.726,10.378-58.169,11.6-66.454.154-1.036.234-1.6.234-1.6l17.185-4.213.568-.14,1.846-.455h46.032l33.855,22.929-.007.241-2.066,63.037-.883,26.968a35.664,35.664,0,0,0-.809,9.937,46.673,46.673,0,0,0,3.116,14.918,53.833,53.833,0,0,0,12.484,18.79c4.781,4.781,7.1,8.807,8.145,11.969Z",
    transform: "translate(21.727 576.647)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.122,223.885c-1.13,9.268-2.213,15.854-2.213,15.854L737.06,259.292l-9.041,14.918-15.6,25.738-2.287,3.778L708.5,304.97H659.559l2.34-2.514,23.31-25.015,3.016-3.23,4.888-5.249,15.279-50.252L726.4,159.484s7.3-2.541,14.417-.134a17.053,17.053,0,0,1,10,9.007C755.69,178.107,753.316,205.991,751.122,223.885Z",
    transform: "translate(19.168 574.799)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.693,220.911l-14.056,27.536L631.18,272.854,625.8,283.392l-2.12,4.159-18.168,16.062H564.372l6.78-8.425,2.521-3.143,9.89-12.29,5.55-6.9,15.065-18.737,4.018-85.336a29.312,29.312,0,0,1,25.487-27.537l.084-.014c4.56-.916,11.809-1.184,17.419,4.24.194.181.381.375.568.575a19.992,19.992,0,0,1,2.648,3.537c.08.134.16.274.234.415a14.317,14.317,0,0,1,.669,1.4c7.162,16.677,2.387,69.516,2.387,69.516Z",
    transform: "translate(26.504 576.155)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.512,
    cy: 32.512,
    r: 32.512,
    transform: "translate(663.949 635.839)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.27,96.57s-3.37-9.286-5.281-14.1-.665-11.071-.665-11.071-25.5-5.629-35.491-.05-10.659-22.485-.523-30.123c0,0,2.714,4.717,1.661,6.074l-1.053,1.356s7.67-16.222,20.623-17.034c0,0,6.139,4.9,3.825,6.515s17.058-9.14,20.428.145c0,0,12.352,2.2,9.945,6.42l.2,2.912s11.2-1.162,10.4,6.771c0,0-3.766-.751-6.175.858s5.73,9.234,5.73,9.234,4.892,31.777-12.072,40.926c0,0,2.751-14.461-3.723-12.1s-7.83,3.269-7.83,3.269Z",
    transform: "translate(20.674 584.563)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.467,322.454H19.533a19.533,19.533,0,1,1,0-39.066H780.467a19.533,19.533,0,1,1,0,39.066Z",
    transform: "translate(70 565.159)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.426,217.83l-1.479,69.037a12.289,12.289,0,0,1-12.286,12.026h-127a12.289,12.289,0,0,1-12.271-11.618l-3.774-69.037a12.289,12.289,0,0,1,12.271-12.96H792.14a12.289,12.289,0,0,1,12.286,12.552Z",
    transform: "translate(20.09 571.179)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.385,
    cy: 30.385,
    r: 30.385,
    transform: "translate(313.158 615.081)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7,149.043l3.343,36.109,22.735,91.61-19.642,6.884-33.184-99.831-4.583-40.121Z",
    transform: "translate(54.018 575.926)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.996,
    cy: 10.614,
    rx: 23.996,
    ry: 10.614,
    transform: "translate(298.426 849.312)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.242,149.277,203.95,76.219s38.115-5.349,39.452,7.356-.956,74.8-.956,74.8l-52.2-9.094Z",
    transform: "translate(55.338 581.212)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.726,63.243s18.8-6.708,26.724-10.318,23.68,21.566,24.03,8.27-5.092-18.871-5.092-18.871-1.359-29.086-30.663-25.45c0,0,6.446-14.552-14.712-16.8S222.939,48.914,225.887,56.55s6.482,13.948-1.882,22.112S199.981,132.9,211.9,145.3s12.7,17.779,4.533,25.492-27.461,24.486-6.6,27.4-1.909.737,13.646-12.945,38.253-13.123,29.778-35.076,6.249-53.409,4.407-58.181,4.128-35.076,4.128-35.076,13.895-2.041,14.934,6.331Z",
    transform: "translate(54.551 587)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.9,591.095l7.352,30.325a1.9,1.9,0,0,1-.037,1.024L431.867,726.657a1.894,1.894,0,0,1-3.686-.363l-4.613-40.6a1.9,1.9,0,0,1,.081-.8l30.61-93.941a1.894,1.894,0,0,1,3.642.141Z",
    transform: "translate(39.627 147.66)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.361,432.512l6.788,26.019-29.414,95.025-6.788-29.412Z",
    transform: "translate(196.463 308.802)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.847,700c1.131,3.394,117.651-1.131,118.782-2.263a24.564,24.564,0,0,0,2.489-4.525c1.063-2.263,2.036-4.525,2.036-4.525l-4.525-36.63-115.388-4.1s-2.885,31.041-3.473,45.25A33.944,33.944,0,0,0,350.847,700Z",
    transform: "translate(-4.217 182.722)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.847,683.008c1.131,3.394,117.651-1.131,118.782-2.263a24.554,24.554,0,0,0,2.489-4.525H350.768A33.944,33.944,0,0,0,350.847,683.008Z",
    transform: "translate(-4.217 199.712)",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTeamworkZplp);
export default __webpack_public_path__ + "static/media/undraw_teamwork_zplp.1eecc630e6489728c1c10cf2e9024d31.svg";
export { ForwardRef as ReactComponent };